import { ClipboardCheckIcon, FolderOpenIcon, LightbulbIcon, SearchCheckIcon, SproutIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  items?: string[];
  note?: string;
  benefit?: string;
  value: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Banco de 150 Actividades de Gestión Ambiental para el Aula',
    description:
      '150 propuestas listas para utilizar o adaptar en clases sobre fundamentos, recursos, aspectos e impactos, agua y suelo, residuos, biodiversidad, cambio climático, sistemas de gestión y desafíos integradores. Organizadas por nivel de dificultad.',
    benefit: 'Materiales ya pensados para el aula: ahorra horas en cada trimestre.',
    value: 'USD 14',
    icon: FolderOpenIcon,
  },
  {
    number: '02',
    title: 'Kit Completo de Evaluación de Gestión Ambiental',
    description: 'Recursos completos para evaluar conocimientos y competencias:',
    items: [
      '200 preguntas de evaluación',
      '30 situaciones problemáticas',
      '20 casos integradores',
      'Evaluaciones temáticas',
      'Evaluaciones integradoras',
      'Criterios de corrección',
      'Rúbricas',
      'Listas de cotejo',
      'Autoevaluaciones',
      'Coevaluaciones',
      'Instrumentos de seguimiento',
      'Evaluación final integradora',
    ],
    benefit: 'Nunca más construyas un examen desde cero bajo presión.',
    value: 'USD 14',
    icon: ClipboardCheckIcon,
  },
  {
    number: '03',
    title: '100 Casos Prácticos de Gestión Ambiental para Analizar y Resolver',
    description: '100 situaciones prácticas para desarrollar análisis, razonamiento y toma de decisiones sobre:',
    items: [
      'Fundamentos de gestión',
      'Recursos naturales',
      'Impactos ambientales',
      'Agua y suelo',
      'Gestión de residuos',
      'Biodiversidad y ecosistemas',
      'Cambio climático',
      'Sistemas de gestión',
      'Conservación y protección',
      'Sostenibilidad',
      'Situaciones profesionales integradoras',
    ],
    benefit: 'Tus alumnos aprenden analizando situaciones reales de gestión ambiental.',
    value: 'USD 14',
    icon: SearchCheckIcon,
  },
  {
    number: '04',
    title: '100 Proyectos Ambientales para el Aula, la Escuela y la Comunidad',
    description: 'Incluye 100 proyectos para trabajar la gestión ambiental desde múltiples dimensiones:',
    items: [
      'Proyectos sobre gestión del agua',
      'Proyectos sobre gestión de residuos',
      'Proyectos sobre consumo responsable',
      'Proyectos sobre energía y recursos',
      'Proyectos sobre biodiversidad',
      'Proyectos sobre prevención de contaminación',
      'Proyectos sobre cambio climático',
      'Proyectos sobre participación ambiental',
      'Proyectos de mejora institucional',
      'Proyectos comunitarios',
    ],
    note: 'Cada proyecto incluye objetivos, procedimientos, recursos necesarios y resultados esperados.',
    benefit: 'Tus alumnos salen con proyectos reales en sus comunidades.',
    value: 'USD 14',
    icon: SproutIcon,
  },
  {
    number: '05',
    title: 'Guía de 100 Estrategias de Gestión Ambiental para Instituciones Educativas',
    description: '100 estrategias prácticas que las instituciones educativas pueden implementar:',
    items: [
      'Estrategias de gestión del agua',
      'Estrategias de gestión de residuos',
      'Estrategias de ahorro de energía',
      'Estrategias de compras sostenibles',
      'Estrategias de conservación de biodiversidad',
      'Estrategias de prevención de contaminación',
      'Estrategias de participación comunitaria',
      'Estrategias de comunicación ambiental',
      'Estrategias de seguimiento e indicadores',
      'Estrategias de mejora continua',
    ],
    note: 'Incluye pasos de implementación, indicadores de éxito y casos de aplicación.',
    value: 'USD 14',
    icon: LightbulbIcon,
  },
];
